import React, { useEffect, useRef, useState } from "react";
import UserDropdown from "./UserDropdown";
import ActionMenuIcon from "../../../../media/icons/assets_light/outline-action-menu-2-active.svg";
import UserIcon from "../../../../media/icons/assets_light/outline-management-person-active.svg";
import Scrollbars from "react-custom-scrollbars";
import { Tooltip } from "react-tooltip";
import { useTaskContext } from "../../../../context/TaskContext";
import { useSelector } from "react-redux";
import { getONLYUSERSDATA } from "../../../../Utils/Common";
import sortArrayByKey from "../../../../Utils/useSortedArray";
import { MdClose } from "react-icons/md";
import toast from "react-hot-toast";

export default function RolePanel() {

  const { OnUpdateTask, isObserver, isAssignee } = useTaskContext()
  const { allUsers, user } = useSelector(state => state.message)
  const { active_task } = useSelector(state => state.task)
  const participants = allUsers?.filter(f => active_task?.participants?.includes(f.id));
  const assign_participants = allUsers?.filter(f => active_task?.participants?.includes(f.id) && !active_task?.observers?.includes(f.id))
  const observer_participants = allUsers.filter(f => active_task?.participants?.includes(f.id) && active_task?.created_by !== f.id && !active_task?.assign_to.includes(f.id));

  const [openAssigned, setOpenAssigned] = useState(false);
  const [openObserver, setOpenObserver] = useState(false);
  const assignedRef = useRef(null);
  const ownerRef = useRef(null);
  const observerRef = useRef(null);

  // Close dropdowns on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        assignedRef.current &&
        !assignedRef.current.contains(event.target)
      ) {
        setOpenAssigned(false);
      }
      // if (
      //   ownerRef.current &&
      //   !ownerRef.current.contains(event.target)
      // ) {
      //   setOpenOwner(false);
      // }
      if (
        observerRef.current &&
        !observerRef.current.contains(event.target)
      ) {
        setOpenObserver(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleAssignUser = (user) => {
    OnUpdateTask({ assign_to: [user.id], save_type: 'assignee' });
  }

  const handleObserverUser = (user) => {
    OnUpdateTask({
      observers: [...active_task?.observers, user.id],
      save_type: 'observer',
    });
  }

  const handleRemoveObserver = (observerId) => {
    OnUpdateTask({
      observers: active_task?.observers?.filter(id => id !== observerId),
      save_type: 'observer',
    });
  }

  const openObservers = () => {
    if (isObserver()) {
      return;
    }
    if (active_task?.assign_to?.length > 0) {

      setOpenObserver(!openObserver)
    } else {
      toast.error("Please assign the task before adding observers.")
    }
  }

  const assign_data = assign_participants?.filter(f => !active_task?.assign_to?.includes(f.id))
  const observer_data = observer_participants?.filter(f => !active_task?.observers?.includes(f.id))

  return (
    <div className="bg-white dark:bg-surface-dark py-4 w-full mb-8">
      <div className="items-start relative">

        {/* LEFT SIDE */}
        <div className="flex w-full gap-4">

          {/* Owner */}
          <div ref={ownerRef} className="w-[calc(50%-8px)]">
            <div className="text-[12px] text-gray-600 dark:text-white mb-1">
              Owner
            </div>
            {/* onClick={() => setOpenOwner(!openOwner)} */}
            <div className="border border-border-primary hover:border-border-action rounded-md  py-2 bg-white dark:bg-surface-dark-2">

              <div className="flex items-start gap-2 px-2">
                <div className="w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center">
                  <div
                    className="w-[16px] h-[16px] bg-[#636E82]"
                    style={{
                      WebkitMaskImage: `url(${UserIcon})`,
                      WebkitMaskRepeat: "no-repeat",
                      WebkitMaskPosition: "center",
                      WebkitMaskSize: "contain",
                      maskImage: `url(${UserIcon})`,
                      maskRepeat: "no-repeat",
                      maskPosition: "center",
                      maskSize: "contain",
                    }}
                  />
                </div>
                <div

                  className="text-[12px]  text-text-body dark:text-white cursor-pointer mt-[2px]"
                >
                  {getONLYUSERSDATA(allUsers, active_task?.owned_by?.[0], 'name') || "Select owner"}
                </div>
              </div>
              {/* <UserDropdown
                placeholderLabel="Select owner"
                selected={owner}
                setSelected={setOwner}
                options={userList}
                open={openOwner}
                setOpen={setOpenOwner}
              /> */}
            </div>
          </div>

          {/* Assigned */}
          <div ref={assignedRef} className="w-[calc(50%-8px)]">
            <div className="text-[12px] text-gray-600 dark:text-white mb-1">
              Assigned
            </div>

            <div onClick={() => { (!isObserver() && (!isAssignee() || (isAssignee() && active_task?.created_by === user?.id))) && setOpenAssigned(!openAssigned) }} className="border border-border-primary hover:border-border-action rounded-md  py-2 bg-white dark:bg-surface-dark-2">

              <div className="flex items-center justify-between px-3">
                <div className="flex items-start gap-2">
                  <div className="w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center">
                    <div
                      className="w-[16px] h-[16px] bg-[#636E82]"
                      style={{
                        WebkitMaskImage: `url(${UserIcon})`,
                        WebkitMaskRepeat: "no-repeat",
                        WebkitMaskPosition: "center",
                        WebkitMaskSize: "contain",
                        maskImage: `url(${UserIcon})`,
                        maskRepeat: "no-repeat",
                        maskPosition: "center",
                        maskSize: "contain",
                      }}
                    />
                  </div>
                  <div className="text-[12px] text-text-body dark:text-white cursor-pointer mt-[2px]">
                    {active_task?.assign_to?.[0] ? getONLYUSERSDATA(allUsers, active_task?.assign_to?.[0], 'name') : "Assignee"}
                  </div>
                </div>
                {active_task?.assign_to?.[0] && (
                  <button
                    onClick={() => handleAssignUser({ id: null })}
                    className="p-1 rounded-full hover:bg-red-100 dark:hover:bg-red-900/30"
                    title="Remove assignee"
                  >
                    {(!isObserver() && (!isAssignee() || (isAssignee() && active_task?.created_by === user?.id))) && <MdClose className="w-4 h-4 text-gray-400 hover:text-red-500 transition-colors" />}
                  </button>
                )}
              </div>
              <UserDropdown
                placeholderLabel="Select assignee"
                selected={active_task?.assign_to}
                setSelected={handleAssignUser}
                options={sortArrayByKey(assign_data, 'firstname', 'asc')}
                open={openAssigned}
                setOpen={setOpenAssigned}
              />
            </div>
          </div>
        </div>

        {/* RIGHT SIDE – OBSERVERS */}
        <div className="flex flex-col w-full relative mt-4">
          <div className="text-[12px] text-gray-600 dark:text-white mb-1">
            Observers ({active_task?.observers?.length})
          </div>
          {!isObserver() && <div
            id="moreObservers"
            onClick={openObservers}
            className="absolute top-[-2px] right-[-8px] w-[24px] h-[24px] bg-[#636E82] hover:!bg-[#318FFF] dark:!bg-[#fff] cursor-pointer transition-colors"
            style={{
              WebkitMaskImage: `url(${ActionMenuIcon})`,
              WebkitMaskRepeat: "no-repeat",
              WebkitMaskPosition: "center",
              WebkitMaskSize: "contain",
              maskImage: `url(${ActionMenuIcon})`,
              maskRepeat: "no-repeat",
              maskPosition: "center",
              maskSize: "contain",
            }}
          />}

          <div className="border border-border-primary hover:border-border-action rounded-md py-2 bg-white dark:border-border-primary dark:bg-surface-dark-2">
            <Scrollbars
              className="observer-scroll-wrapper group min-h-32 max-h-40"     // REQUIRED for autoHide
              autoHide={true}

              renderTrackVertical={({ style, ...props }) => (
                <div
                  {...props}
                  style={{
                    ...style,
                    right: "0px",
                    width: "6px",
                    top: "0",
                    bottom: "0",
                    position: "absolute",
                  }}
                />
              )}
              renderThumbVertical={({ style, ...props }) => (
                <div
                  {...props}
                  style={{
                    ...style,
                    backgroundColor: "#0B1F47",
                    borderRadius: "50px",
                  }}
                />
              )}
            >
              {/* .filter((user) => user !== owner && user !== assigned) */}
              {active_task?.observers.map((id, idx) => (
                <div key={idx}
                  className="flex items-center justify-between cursor-pointer gap-2 px-3 py-2 hover:bg-gray-200 dark:hover:bg-gray-700 transition group"
                >
                  <div className="flex items-center gap-2">
                    {/* User Icon */}
                    <div className="w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center">
                      <div
                        className="w-[16px] h-[16px] bg-[#636E82]"
                        style={{
                          WebkitMaskImage: `url(${UserIcon})`,
                          WebkitMaskRepeat: "no-repeat",
                          WebkitMaskPosition: "center",
                          WebkitMaskSize: "contain",
                          maskImage: `url(${UserIcon})`,
                          maskRepeat: "no-repeat",
                          maskPosition: "center",
                          maskSize: "contain",
                        }}
                      />
                    </div>

                    <span className="text-[12px] text-text-body dark:text-white">
                      {getONLYUSERSDATA(allUsers, id, 'name')}
                    </span>
                  </div>

                  {/* Remove Observer Icon */}
                  {!isObserver() &&
                    <button
                      onClick={() => handleRemoveObserver(id)}
                      className="p-1 rounded-full hover:bg-red-100 dark:hover:bg-red-900/30"
                      title="Remove observer"
                    >
                      <MdClose className="w-4 h-4 text-gray-400 hover:text-red-500 transition-colors" />
                    </button>
                  }
                </div>
              ))}
              {active_task?.observers.length === 0 && (
                <div className="text-[12px] text-gray-600 dark:text-white px-4 py-2">
                  No observers selected
                </div>
              )}
            </Scrollbars>
            <div ref={observerRef} className="absolute top-[18px] w-full z-50 bg-white dark:bg-surface-dark">
              <UserDropdown
                placeholderLabel="Select observer"
                selected={active_task?.observers}
                setSelected={handleObserverUser}
                options={sortArrayByKey(observer_data, 'firstname', 'asc')}
                open={openObserver}
                setOpen={setOpenObserver}
              />
            </div>
          </div>

        </div>

      </div>
    </div>
  );
}
